export const breakpoints = {
  sm: 576,
  md: 768,
  lg: 980,
  xl: 1280,
  xxl: 1600,
  test: width => window.matchMedia(`(max-width: ${width}px)`).matches,
  testBetween: (min, max) => window.matchMedia(`(min-width: ${min}px) and (max-width: ${max}px)`).matches,
};

export default breakpoints;
